import React from 'react';
import {
    Grid,
    Container,
    Typography, Card, CardContent,
} from '@material-ui/core';
import { useTranslation } from "react-i18next";
import Page from 'components/Page';
import NotPricedPackageTable from './NotPricedPackageTable';
import TableFilter from "../../../components/TableFilter";
import {createUrlQuery} from "../../../helpers";

export default function NotPricedPackageStatistics({ ...rest }) {
    const { t } = useTranslation();
    const [filter, setFilter] = React.useState({});
    const [params, setParams] = React.useState('');

    const setFilterValue = (name, value) => {
        let tmpFilter = { ...filter, [name]: value };
        setParams( createUrlQuery(tmpFilter) );
        setFilter({ ...filter, [name]: value });
    }

    return (
        <Page
            title={t('navbar.not_priced')}
        >
            <Container maxWidth={false}>
                <Typography variant="h1" gutterBottom >
                    {t('navbar.not_priced')}
                </Typography>
                <Grid container spacing={3} alignItems="center" >
                    <Grid item xs={12}>
                        <Card>
                            <CardContent>
                                <TableFilter
                                    filter={filter}
                                    enabled={{
                                        status_type: false,
                                        cod_payment: false,
                                        created_at: true,
                                        user: false,
                                        partner: false,
                                        delivery_type: true,
                                        reverse: false,
                                        shipper: true,
                                    }}
                                    setFilterValue={setFilterValue}
                                />
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12}>
                        <NotPricedPackageTable params={params}/>
                    </Grid>
                </Grid>
            </Container>
        </Page>
    );
}